import { useTranslation } from 'react-i18next';

import { ScreenIcon } from 'src/components/Icons/icons';
import { OrganizationModuleType } from 'src/domain/organization';
import { ModuleSettingsScreen } from '../components/ModuleSettingsScreen';

export const InfoScreenSettings = () => {
    const { t } = useTranslation();

    return (
        <ModuleSettingsScreen
            basePath="/app/info-screen"
            icon={ScreenIcon}
            moduleType={OrganizationModuleType.infoScreen}
            moduleName={t('modules.infoScreen.navLabel')}
            memberDescription={t(
                'modules.infoScreen.members.settingsDescription',
            )}
        />
    );
};
